export function priceField(
  column,
  name,
  label,
  readOnly = false,
  defaultValue = '0',
  component,
) {
  return {
    name: name,
    label: label,
    type: 'number',
    defaultValue: defaultValue,
    mandatory: true,
    column: column,
    scale: 2,
    fixedDecimalScale: true,
    suffix: 'zł',
    component: component,
    readOnly: readOnly,
  };
}

export function withAutocomplete(field, autoComplete) {
  return {
    ...field,
    autoComplete,
  };
}

export const common = {
  machineType: {},
};

export default common;
